import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../App/Theme";

import Link from "@material-ui/core/Link";

import { getModName, shouldComponentUpdateGB } from "../NonComponents/GBUtil";

class GBRedirectForm extends React.Component {
    static propTypes = {
        appBarHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    static defaultProps = {
        appBarHeight: 50,
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        const divHeight = 150; //290;
        const divPadding = 50;

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: this.props.appBarHeight + 20,
                }}
            >
                <div
                    style={{
                        alignItems: "center",
                        borderColor: Theme.HL_PrimaryColor,
                        borderRadius: Theme.VM_DivBorderRadius,
                        borderWidth: "thin",
                        borderStyle: "solid",
                        display: "flex",
                        flexWrap: "wrap",
                        fontSize: 22,
                        height: divHeight,
                        justifyContent: "center",
                        marginTop: 25,
                        padding: divPadding,
                        position: "absolute",
                        width: 750,
                    }}
                >
                    <p
                        style={{
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        This version of the VMMC Implementation Planning Toolkit cannot be used with any of your
                        permitted countries. Please click the link below to proceed to the previous version.
                        <br />
                        <br />
                        <Link
                            onClick={() => window.open("http://www.vmmcipt.org/2020", "_self")}
                            style={{
                                color: Theme.HL_SecondaryColor,
                                cursor: "pointer",
                            }}
                            underline={"hover"}
                        >
                            http://www.vmmcipt.org/2020
                        </Link>
                    </p>
                </div>
            </div>
        );
    }
}

export default GBRedirectForm;
